import styles from './style.module.css';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {NEW_TASK_STEP} from '../../constants';

const PATH_MATCH={
    "/new-task-app":{title:'Application',step:0},
    "/new-task-data":{title:'Dataset',step:1},
    "/new-task-data-v2":{title:'Dataset',step:1},
    "/new-task-device":{title:'Device Clustering',step:2},
    "/new-task-train":{title:'Training Setting',step:3},
}

export default function NewTaskHeader(){
    const location = useLocation();
    const [stepInfo,setStepInfo]=useState(PATH_MATCH[location.pathname]);

    useEffect(()=>{
        setStepInfo(PATH_MATCH[location.pathname]);
    },[location.pathname])

    return(
        <div className={styles['wrap']}>
            <p>
                <span>New Task</span>
                <span>&gt;</span>
                <span>{stepInfo.title}</span>
            </p>
            <div className={styles['step']}>   
                <div className={styles['step']}>   
                    {NEW_TASK_STEP.map((title,index)=><>
                    <span className={`
                    ${styles['dot']} 
                    ${
                        stepInfo.step > index ? styles['dot-done']
                        :
                        stepInfo.step === index ? styles['dot-do']
                        :
                        ""
                    }`
                    }>{title}</span>
                    {index!==3&&
                    <svg className={styles['dashed']}>
                        <line
                        x1='0'
                        x2='100'
                        y1='5'
                        y2='5'
                        stroke={stepInfo.step<=index?'var(--color-placeholder)':"var(--color-text)"}
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeDasharray={stepInfo.step<=index?'5 10':"0"}
                        strokeDashoffset='12'
                        style={{
                            transition:"stroke-dasharray 250ms var(--transition-ease-out-sl"
                        }}
                        />
                    </svg>}
                    </>)}
                </div>
            </div>
        </div>
    )
}